import { jsx as n } from "react/jsx-runtime";
import $ from "clsx";
import { forwardRef as j, useId as E } from "react";
import { Link as L } from "react-router-dom";
import '../Button.css';const U = Symbol("InGUItiv Button");
function G({
  autoFocus: m = !1,
  color: p = "default",
  type: g,
  className: f,
  disabled: i,
  isActive: e,
  allowInteractionWhenDisabled: r = !1,
  inputId: d,
  linkTo: u,
  rounding: h = "rounded",
  children: o,
  insetFocus: k,
  touchingTop: B,
  touchingBottom: y,
  touchingLeft: I,
  touchingRight: _,
  onClick: l,
  onDoubleClick: c,
  onFocus: x,
  onMouseEnter: C,
  onMouseLeave: N,
  ...v
}, s) {
  const O = E(), S = d ?? O, t = (!g && u ? "link" : g) ?? "button", a = {
    id: S,
    className: "inguitiv-button__button",
    onClick: (b) => {
      if (i && !r) {
        b.preventDefault();
        return;
      }
      l?.({ originalEvent: b });
    },
    onDoubleClick: (b) => {
      !c || i && !r || c({ originalEvent: b });
    },
    onFocus: x,
    onMouseEnter: C,
    onMouseLeave: N
  };
  return /* @__PURE__ */ n(
    "span",
    {
      className: $([
        f,
        "inguitiv-button",
        `inguitiv-button--color-${p}`,
        `inguitiv-button--type-${u ? "link" : t}`,
        `inguitiv-button--shape-${h}`,
        {
          "inguitiv-button--inset-focus": k,
          "inguitiv-button--is-disabled": i,
          "inguitiv-button--is-active": e,
          "inguitiv-button--has-link": t === "link" && u,
          "inguitiv-button--has-action": l || c || t === "submit",
          "inguitiv-button--touch-top": B,
          "inguitiv-button--touch-bottom": y,
          "inguitiv-button--touch-left": I,
          "inguitiv-button--touch-right": _
        }
      ]),
      children: t === "link" ? /* @__PURE__ */ n(
        L,
        {
          ref: s,
          ...a,
          ...v,
          to: u ?? "",
          "aria-selected": e,
          "aria-disabled": i,
          children: o
        }
      ) : t === "tab" ? /* @__PURE__ */ n(
        "span",
        {
          ref: s,
          ...a,
          "aria-selected": e,
          role: "tab",
          children: o
        }
      ) : t === "button" || t === "submit" || t === "reset" ? /* @__PURE__ */ n(
        "button",
        {
          ref: s,
          ...a,
          ...v,
          autoFocus: m,
          disabled: i && !r,
          "aria-disabled": i,
          type: t,
          children: o
        }
      ) : /* @__PURE__ */ n("span", { ref: s, ...a, children: o })
    }
  );
}
const F = Object.assign(j(G), {
  symbol: U
});
export {
  F as Button,
  U as IS_BUTTON_SYMBOL
};
